import React from 'react'; 
import WithConsumer from '../../context/WithConsumer';

const Contact = ({ context }) => {
		 
    const posts = () => context.posts;
    const post = posts()[0];
         
    if (post) {
				
		return (					
			<div className="c-contact">
				<div className="l-content">
					<div className="c-contact__desktop">
						<div className="scope-contact-desktop-text" dangerouslySetInnerHTML={ {__html:post.contact_text}}></div>
					</div>
					<div className="c-contact__mobile">
						<div className="scope-contact-mobile-text" dangerouslySetInnerHTML={ {__html:post.contact_text_mobile}}></div>
					</div>
				</div>
			</div>				
		)
			
	} else {
		
		return null;
	
	}
};
export default WithConsumer(Contact);